// libs
import isEmpty from 'lodash/isEmpty';

export const isSKUChanged = ({
  routeID,
  routeSKU,
  productSKU,
  productID,
}: {
  routeID?: string;
  routeSKU?: string;
  productSKU?: string;
  productID?: string;
}) => {
  if (isEmpty(productID) || isEmpty(productSKU)) {
    return true;
  }

  if (isEmpty(routeSKU) === false && (productSKU === routeSKU || productID === routeSKU)) {
    return false;
  }

  if (isEmpty(routeID) === false && (productSKU === routeID || productID === routeID)) {
    return false;
  }

  return true;
};
